import { contextApi } from "../context/contextApi";
import { useContext, useEffect } from "react";

function UnSuccess() {
    const context = useContext(contextApi)
    useEffect(() => {
        context.setLogin(false)
    }, []);
    return (
        <div className="flex flex-col h-full w-full ">
            <div className="m-auto">
                <img src="/images/close.svg" />
                <p className="my-5">تراکنش شما ناموفق بود</p>
            </div>
        </div>
    );
}

export default UnSuccess;